(function () {
    'use strict';
    $(document).ready(function () {
        if ($('.interactive-map').length) {
            const lang = $('html').attr('lang');
            const {
                IMG_REGION_MAIN,
                IMG_STATEK,
                IMG_STACJE,
                IMG_STACJE_SK,
                IMG_WYDOBYWCZE,
                IMG_WYDOBYWCZE_CA,
                IMG_RAFINERYJNE,
                IMG_PETROCHEMICZNE,
                IMG_ENERGETYCZNE,
                REGIONS_VALUES,
                REGIONS_LEGEND,
            } = MAP_DATA;

            const MARKERS = [
                { latLng: [30, -150], name: MAP_TRANSLATIONS.sprzedaz_morska },
                { latLng: [30, -45], name: MAP_TRANSLATIONS.sprzedaz_morska },
                { latLng: [-15, 76], name: MAP_TRANSLATIONS.sprzedaz_morska },
                { latLng: [60, -110], name: MAP_TRANSLATIONS.aktywa_wydobywcze }, //CA
                { latLng: [52.5, 17.5], name: MAP_TRANSLATIONS.stacje_paliw }, //PL
                { latLng: [52.5, 19.1], name: MAP_TRANSLATIONS.aktywa_wydobywcze }, //PL
                { latLng: [52.5, 20.67], name: MAP_TRANSLATIONS.aktywa_rafineryjne }, //PL
                { latLng: [51.5, 18.33], name: MAP_TRANSLATIONS.aktywa_petrochemiczne }, //PL
                { latLng: [51.5, 20], name: MAP_TRANSLATIONS.aktywa_energetyczne }, //PL
                { latLng: [51.0, 10.5], name: MAP_TRANSLATIONS.stacje_paliw }, //DE
                { latLng: [50.5, 13.5], name: MAP_TRANSLATIONS.stacje_paliw }, //CZ
                { latLng: [50.5, 15], name: MAP_TRANSLATIONS.aktywa_rafineryjne }, //CZ
                { latLng: [49.65, 14.25], name: MAP_TRANSLATIONS.aktywa_petrochemiczne }, //CZ
                { latLng: [49.65, 15.7], name: MAP_TRANSLATIONS.aktywa_energetyczne }, //CZ
                { latLng: [55.5, 23.5], name: MAP_TRANSLATIONS.stacje_paliw }, //LT
                { latLng: [55.5, 25], name: MAP_TRANSLATIONS.aktywa_rafineryjne }, //LT
                { latLng: [54.6, 24.25], name: MAP_TRANSLATIONS.aktywa_energetyczne }, //LT
                { latLng: [49, 20.1], name: MAP_TRANSLATIONS.stacje_paliw }, //SK
            ];
            const REGIONS = { ...REGIONS_VALUES }

            const $map = $('#interactive-map');
            const $mapLegend = $('.map-container .map-legend');
            let filteredMapMarkersNodes = [];
            let areMarkersVisible = true;
            let isLegendOpen = false;

            const mapArgs = {
                map: `world_mill_${lang}`,
                markers: MARKERS,

                regionStyle: {
                    initial: {
                        fill: "#E6E6E7",
                        cursor: 'pointer',
                    },
                    hover: {
                        fill: '#F00',
                    },
                },
                backgroundColor: "#FFF",
                panOnDrag: true,
                zoomMax: 7,
                focusOn: {
                    x: 0.5,
                    y: 0.5,
                    scale: 1,
                    animate: true
                },

                series: {
                    markers: [
                        {
                            attribute: 'fill',
                            scale: ['#345', '#678'],
                        },
                        {
                            attribute: 'image',
                            scale: {
                                statek: IMG_STATEK,
                                stacje: IMG_STACJE,
                                stacje_sk: IMG_STACJE_SK,
                                wydobywcze: IMG_WYDOBYWCZE,
                                wydobywcze_ca: IMG_WYDOBYWCZE_CA,
                                rafineryjne: IMG_RAFINERYJNE,
                                petrochemiczne: IMG_PETROCHEMICZNE,
                                energetyczne: IMG_ENERGETYCZNE,
                            },
                            values: {
                                '0': 'statek',
                                '1': 'statek',
                                '2': 'statek',
                                '3': 'wydobywcze_ca', //CA
                                '4': 'stacje', //PL
                                '5': 'wydobywcze', //PL
                                '6': 'rafineryjne', //PL
                                '7': 'petrochemiczne', //PL
                                '8': 'energetyczne', //PL
                                '9': 'stacje', //DE
                                '10': 'stacje', //CZ
                                '11': 'rafineryjne', //CZ
                                '12': 'petrochemiczne', //CZ
                                '13': 'energetyczne', //CZ
                                '14': 'stacje', //LT
                                '15': 'rafineryjne', //LT
                                '16': 'energetyczne', //LT
                                // '17': 'stacje', //PL
                                '17': 'stacje_sk', //SK
                            },
                        }
                    ],
                    regions: [
                        {
                            scale: {
                                red: '#c0c0c0',
                                main: IMG_REGION_MAIN
                            },
                            attribute: 'fill',
                            values: REGIONS
                        }]
                },

                onMarkerClick: function (event, label, index) {
                    if (label < 3) {
                        interactiveMapGetInfo('M');
                    }
                },
                onRegionClick: function (event, label, index) {
                    interactiveMapGetInfo(label);
                },


                onViewportChange: (event, scaleFactor) => {
                    if (scaleFactor > 6) showMarkers();
                    else hideMarkers();
                }
            }
            $map.vectorMap(mapArgs);

            const $companiesContainer = $('.interactive-map .companies-container');

            // Markers hide
            const mapObject = $map.vectorMap('get', 'mapObject');
            const filteredMarkers = Object.values(mapObject.markers).filter(marker => parseInt(marker.element.config.index) > 3);
            filteredMapMarkersNodes = [...filteredMarkers];
            hideMarkers();

            function showMarkers() {
                if (filteredMapMarkersNodes.length > 0 && !areMarkersVisible) {
                    filteredMapMarkersNodes.forEach(marker => $(marker.element.shape.node).stop().fadeIn());
                    areMarkersVisible = !areMarkersVisible;
                }
            }

            function hideMarkers() {
                if (filteredMapMarkersNodes.length > 0 && areMarkersVisible) {
                    filteredMapMarkersNodes.forEach(marker => $(marker.element.shape.node).stop().fadeOut());
                    areMarkersVisible = !areMarkersVisible;
                }
            }

            // Legend logic
            $('.map-legend .close-button').on('click', mapLegendClose)

            function interactiveMapGetInfo(code) {

                if (REGIONS_LEGEND[code]) {
                    const { region_name, products, companies } = REGIONS_LEGEND[code];
                    $mapLegend.find('.region-name').html(region_name);
                    $mapLegend.find('.scroll-wrapper').find('ul')
                        .empty()
                        .html(products.reduce((accumulator, product) => accumulator + `<li>${product}</li>`, ''))

                    if (companies.length > 0) {
                        $companiesContainer.html('');
                        companies.forEach(company =>
                            $companiesContainer.append(`
                                <div>
                                    <img src="${company}" alt="Logo" class="company-logo">
                                </div>
                            `)
                        )
                    }

                    mapLegendOpen();
                }

            }

            function mapLegendOpen() {
                if (!isLegendOpen) {
                    $mapLegend.fadeIn();
                    isLegendOpen = true;
                }

                // Setup scroll
                const listHeight = $mapLegend.find('ul.products-list').height();
                const containerHeight = $mapLegend.find('.scroll-wrapper').height();
                if (listHeight > containerHeight) {
                    $mapLegend.find('.scroll-wrapper').addClass('scrollable');
                    $mapLegend.find('.scroll-wrapper').mCustomScrollbar({
                        axis: "y",
                        mouseWheel: {
                            enable: true
                        }
                    });
                } else {
                    $mapLegend.find('.scroll-wrapper').removeClass('scrollable');
                    $mapLegend.find('.scroll-wrapper').mCustomScrollbar('destroy');
                }
            }

            function mapLegendClose() {
                if (isLegendOpen) {
                    $mapLegend.fadeOut();
                    isLegendOpen = false;
                }
            }

        }
    });
}(jQuery));
